import { useEffect, useState } from "react";
import { formatAmountUnitDecimalPlace } from "@/utility/common";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
export const useColumnDefs = (caseData: any) => {
  const { t } = useTranslation();
  const amountCellRenderer = (field: string) => (params: any) => {
    const { defaultUnit } = caseData;
    const decimalPlace = defaultUnit?.decimalPlace;
    const amount = params.data[field];
    const formattedDefaultAmount = formatAmountUnitDecimalPlace(
      amount,
      decimalPlace
    );
    return formattedDefaultAmount !== "-"
      ? `${formattedDefaultAmount} ${defaultUnit?.name}`
      : formattedDefaultAmount;
  };
  const CustomHeader = () => {
    const { defaultUnit } = caseData;
    const [unitName, setUnitName] = useState(defaultUnit?.name);

    useEffect(() => {
      setUnitName(defaultUnit?.name);
    }, [defaultUnit]);

    return `(${unitName})`;
  };

  return [
    {
      minWidth: 150,
      flex: 1,
      field: "name",
      headerName: t("pages.debtors.debtorsTabelColumnsDetails.name"),
      type: "nameType",
      sortable: true,
      resizable: true,
      comparator: () => 0,
      unSortIcon: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      autoHeight: true,
      wrapText: true,
      cellRenderer: (params: any) => (
        <Link to={`./debtor/edit/` + params?.data?.debtorId}>
         <span className='text-bold-underline'>{params?.data?.name}</span>
        </Link>
      ),
    },
    {
      minWidth: 130,
      flex: 1,

      cellRenderer: "totalClaims",
      comparator: () => 0,
      field: "totalClaims",
      type: "totalClaimsType",
      sortable: true,
      unSortIcon: true,
      headerName: t("pages.debtors.debtorsTabelColumnsDetails.totalClaims", {
        unitName: CustomHeader(),
      }),
      resizable: true,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      minWidth: 200,
      cellRenderer: amountCellRenderer("originalAmount"),
      comparator: () => 0,
      field: "originalAmount",
      type: "originalAmountType",
      sortable: true,
      unSortIcon: true,
      headerName: t("pages.debtors.debtorsTabelColumnsDetails.originalClaims", {
        unitName: CustomHeader(),
      }),
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      minWidth: 200,
      cellRenderer: amountCellRenderer("latestCreditorPositionAmount"),
      comparator: () => 0,
      field: "latestCreditorPositionAmount",
      type: "latestCreditorPositionAmountType",

      sortable: true,
      unSortIcon: true,
      headerName: t(
        "pages.debtors.debtorsTabelColumnsDetails.latestCreditorPosition",
        { unitName: CustomHeader() }
      ),
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      minWidth: 200,
      cellRenderer: amountCellRenderer("latestDebtorPositionAmount"),
      comparator: () => 0,
      field: "latestDebtorPositionAmount",
      type: "latestDebtorPositionAmountType",
      headerName: t(
        "pages.debtors.debtorsTabelColumnsDetails.latestDebtorPositionAmount",
        { unitName: CustomHeader() }
      ),
      sortable: true,
      unSortIcon: true,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      minWidth: 150,
      cellRenderer: amountCellRenderer("resolvedAmount"),
      comparator: () => 0,
      field: "resolvedAmount",
      type: "resolvedAmountType",
      sortable: true,
      unSortIcon: true,
      headerName: t("pages.debtors.debtorsTabelColumnsDetails.resolvedAmount", {
        unitName: CustomHeader(),
      }),
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      cellRenderer: "actionCellRenderers",
      comparator: () => 0,
      minWidth: 70,
      field: "action",
      flex: 1,
      headerName: "",
      sortable: false,
      cellClass: "align-right",
    },
  ];
};
